<template>
    <v-dialog width="800px" v-model="show">
        <v-card>
            <v-toolbar color="red" dark>
                <v-toolbar-title>{{$t('lang.search.view_column')}}</v-toolbar-title>
            </v-toolbar>
            <v-data-table :items="items" :headers="fields"
                          :total-items="totalRows"
                          :rows-per-page-items="rowsPerPageItems"
                          @update:pagination="onPaging">
                <template slot="items" slot-scope="data">
                    <td>
                        {{pageSize*(currentPage-1)+ data.index+1}}
                    </td>
                    <td><a>{{data.item['columnName']}}</a></td>
                    <td>{{data.item['type']}}</td>
                    <td>{{data.item['key']}}</td>
                    <td><v-select :items="selectOption" v-model="data.item['comment']" title="=title,content,no_index"></v-select></td>
                </template>
            </v-data-table>
            <div style="text-align: right">
                <v-btn v-if="this.$store.state.auth.accessLevel == 2" color="primary" dark @click="onApply"><v-icon dark left>save</v-icon>{{$t('lang.common.apply')}}</v-btn>
                <!--v-btn color="error" dark @click="onCancel"><v-icon dark left>cancel</v-icon>Cancel</v-btn-->
            </div>
        </v-card>
    </v-dialog>
</template>

<script>
    import axios from "axios/index";
    import VueController from "../../../../public/js/controller";

    export default {
        name: 'column-dlg',
        components: {},
        inheritAttrs: true,
        props: {
            show: {
                type: Boolean,
                default: false
            },
            rowsPerPageItems: {
                type: [Array, Number],
                default: () => [10, 20, 30, 40, 50]
            }
        },
        created() {
            VueController.push(this);
        },
        destroyed(){
          VueController.removeComponentByEl(this);
        },
        data: () => {
            return {
                selectOption:[
                    {value:"",text:""},
                    {value:"title",text:"title"},
                    {value:"content",text:"content"},
                    {value:"no_index",text:"no_index"}
                ],
                fields: [
                    {value: "index", text: "Index", width: "10%", sortable: false},
                    {value: 'columnName', text: 'Column Name', width: "35%", sortable: false},
                    {value: 'type', text: 'Type', width: "15%", sortable: false},
                    {value: 'key', text: 'Key', width: "15%", sortable: false},
                    {value: 'comment', text: 'Index Option', width: "25%", sortable: false}
                ],
                show:false,
                values: {},
                items: [],
                pagination: {},
                pageSize: 10,
                currentPage: 1,
                totalRows: 0
            }
        },
        methods: {
            onShow:function(sh){
                this.show = sh;
            },

            onSelect: function (data) {
                this.show = false;
                let formSubmit = VueController.getComponentByComponentName("form-submit");
                formSubmit.onShowForm(data.processDefinitionId);
            },

            onPaging: function (page) {
                this.pagination = page.page;
                this.currentPage = page.page;
                this.pageSize = page.rowsPerPage;
            },

            onApply: function(){
                this.onShow(false);
            },

            onCancel: function(){
                this.onShow(false);
            }
        }
    }
</script>
